import { Spacing } from '@persona-id/design-tokens';
import { ZapIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';
import {
  LEGACY_EXTERNAL_INTEGRATION_VENDOR_ICON,
  LEGACY_VENDOR_USE_CASE_ICON,
  LegacyExternalIntegrationVendor,
  LegacyVendorUseCase,
} from 'lib/constants/externalIntegrationVendors';

const VendorInfo = styled('div')`
  display: flex;
  flex-direction: row;
  border-radius: ${({ theme }) => theme.card.borderRadius};
`;
const VendorDescription = styled(Paragraph)`
  margin-bottom: ${Spacing[5]};
`;

const VendorMain = styled('div')`
  display: flex;
  flex-direction: column;
  width: 85%;
  border-radius: ${({ theme }) => theme.card.borderRadius};
`;

const VendorUtilWrapper = styled('div')`
  display: flex;
  margin: ${Spacing[2]} 0px 0px 0px;
  padding: ${Spacing[4]};
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.card.borderRadius};
  border: 1px solid ${({ theme }) => theme.color.background.secondary};
`;

const ActionIcon = styled('div')`
  padding: 6px;
  margin-right: 20px;
  width: 40px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.color.background.secondary};
  border: 1px solid ${({ theme }) => theme.color.background.secondary};
`;

const ModalSidebar = styled('div')`
  display: flex;
  flex-direction: column;
`;

const ButtonContainer = styled('div')`
  margin: 10px 0px 0px 25px;
  width: 110px;
`;

interface ExternalIntegrationVendorModalProps {
  vendor: LegacyExternalIntegrationVendor;
  handleClose: () => void;
}

const ExternalIntegrationVendorModal = ({
  vendor,
  handleClose,
}: ExternalIntegrationVendorModalProps) => {
  const { description } = vendor;

  const Icon = LEGACY_EXTERNAL_INTEGRATION_VENDOR_ICON(vendor);

  return (
    <ModalContainer>
      <ModalHeader onClose={handleClose}>
        <Icon />
      </ModalHeader>
      <ModalBody>
        <VendorInfo>
          <VendorMain>
            <VendorDescription>{description}</VendorDescription>
          </VendorMain>
          <ModalSidebar>
            <ButtonContainer>
              <Button
                data-marketing-id='app-marketplace__get-started'
                id='app-marketplace__get-started'
                onClick={() => {
                  window.open('/dashboard/contact-us?category=sales', '_blank');
                }}
              >
                Contact Us
              </Button>
            </ButtonContainer>
          </ModalSidebar>
        </VendorInfo>
        {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
        {vendor['use-cases']?.length > 0 && (
          <>
            <Paragraph>Use it to...</Paragraph>
            {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
            {vendor['use-cases'].map((useCase: LegacyVendorUseCase, index: number) => {
              const Icon =
                useCase.action in LEGACY_VENDOR_USE_CASE_ICON
                  ? LEGACY_VENDOR_USE_CASE_ICON[useCase.action]
                  : ZapIcon;
              return (
                <VendorUtilWrapper key={index}>
                  <ActionIcon>
                    <Icon />
                  </ActionIcon>
                  <Paragraph>{useCase.description}</Paragraph>
                </VendorUtilWrapper>
              );
            })}
            {vendor['additional-info'] && (
              <>
                <Spacer height={1} />
                <Paragraph>{vendor['additional-info']}</Paragraph>
              </>
            )}
          </>
        )}
      </ModalBody>
    </ModalContainer>
  );
};

export default ExternalIntegrationVendorModal;
